import React, { useEffect, useState } from "react";

import BackToTop from "../../components/elements/BackToTop";
import Header from "../../components/Layout/Header";

import Footer from "../../components/Layout/Footer";

import CtaTwo from "../../components/Common/CtaSection/CtaTwo";
import VtdMain from "./VtdMain";

const navImg1 = `${process.env.PUBLIC_URL}/logowhitebg.png`;

const Vtd = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollTop = window.scrollY;
    setIsVisible(scrollTop > 300);
  };

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Header
        navImg={navImg1}
        parentMenu="Resources"
        activeMenu="/vtd"
      />
      <VtdMain />
      {/* Call to Action */}
      <CtaTwo />
      <BackToTop scroll={isVisible} />
      <Footer />
    </>
  );
};

export default Vtd;
